import MfaCodeForm from "@/components/MfaCodeForm";
import { takeLoginNotice } from "@/lib/api";
import { GDPR_TEXT_VERSION } from "@/lib/gdpr";
import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { PasswordInput } from "@/components/Layout";
import logo from "@/assets/HR.png";
import { loadPlatformVersion } from "@/lib/version";

export default function LoginNavy() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [gdprConsent, setGdprConsent] = useState(false);
  const [version, setVersion] = useState("");
  useEffect(() => { loadPlatformVersion().then(setVersion); }, []);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [mfaToken, setMfaToken] = useState(null);   // al doilea pas (2FA)
  const [notice] = useState(() => takeLoginNotice());   // de ce am fost deconectat (parola s-a schimbat)

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (!gdprConsent) {
      setError("Trebuie să fii de acord cu prelucrarea datelor cu caracter personal (GDPR) pentru a continua.");
      return;
    }
    setLoading(true);
    try {
      const r = await login(username.trim().toLowerCase(), password, { gdprAccepted: gdprConsent });
      if (r?.mfa_required) setMfaToken(r); else nav("/");
    }
    catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Autentificare eșuată");
    } finally { setLoading(false); }
  };

  return (
    <div className="login-grid">
      <div className="login-brand" style={{
        background: "linear-gradient(135deg, #0A1930 0%, #172A46 45%, #1E3A8A 100%)",
        color: "white",
        display: "flex", flexDirection: "column", justifyContent: "space-between"
      }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4 }}>
          <img src={logo} alt="Platforma de HR" style={{ height: 100, width: "auto", filter: "invert(1)" }} />
          <div style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, fontSize: 26, letterSpacing: "-0.02em" }}>
            Platforma de HR
          </div>
        </div>
        <div>
          <h1 className="login-title" style={{ fontSize: 42, fontWeight: 800, lineHeight: 1.1, letterSpacing: "-0.02em", margin: 0 }}>
            Digitalizează procesele<br/>de resurse umane
          </h1>
          <div className="login-roles" style={{ marginTop: 32, display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16, maxWidth: 460 }}>
            {[["Angajat","Introduce și vizualizează"],["Manager","Aprobă"],["HR","Monitorizează"]].map(([k,v]) => (
              <div key={k} style={{ borderLeft: "2px solid #60A5FA", paddingLeft: 12 }}>
                <div style={{ fontSize: 11, opacity: 0.6, letterSpacing: "0.05em", textTransform: "uppercase" }}>{k}</div>
                <div style={{ fontSize: 15, fontWeight: 600 }}>{v}</div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ opacity: 0.4, fontSize: 11 }}>
          © {new Date().getFullYear()} | ONOMAD - Platforma de HR{version && ` | Versiunea ${version}`} | Crafted by S.M.
        </div>
      </div>

      <div className="login-form-side">
        {mfaToken ? <MfaCodeForm token={mfaToken.mfa_token} info={mfaToken} onDone={() => nav("/")} onBack={() => { setMfaToken(null); setPassword(""); }} /> : (
        <form onSubmit={submit} style={{ width: "100%", maxWidth: 380 }} data-testid="login-form">
          {notice && <div style={{ background: "#FEF3C7", color: "#78350F", padding: "10px 14px", borderRadius: 8, marginBottom: 14, fontSize: 13 }} data-testid="login-notice">{notice}</div>}
          <h2 style={{ fontSize: 26, fontWeight: 700, color: "#0A1930", margin: "0 0 6px" }}>Autentificare</h2>
          <p style={{ color: "#64748B", fontSize: 14, marginBottom: 28 }}>Introduceți datele de acces</p>

          <div style={{ marginBottom: 16 }}>
            <label className="label label-req">Utilizator</label>
            <input className="input" value={username} onChange={e=>setUsername(e.target.value)}
              autoFocus autoComplete="username" data-testid="login-username" />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label className="label label-req">Parolă</label>
            <PasswordInput value={password} onChange={e=>setPassword(e.target.value)}
              autoComplete="current-password" testId="login-password" />
          </div>

          <div style={{ display:"flex", alignItems:"flex-start", gap:8, marginBottom:20 }}>
            <input type="checkbox" checked={gdprConsent} onChange={e=>setGdprConsent(e.target.checked)}
              id="gdpr-consent" data-testid="login-gdpr-consent" style={{ marginTop:3 }} />
            <label htmlFor="gdpr-consent" style={{ fontSize:12.5, color:"#475569", lineHeight:1.4, cursor:"pointer" }}>
              Sunt de acord cu prelucrarea datelor mele cu caracter personal în conformitate cu
              Regulamentul (UE) 2016/679 (GDPR), în scopul autentificării și utilizării platformei.
              <span style={{ display: "block", fontSize: 11, opacity: .7, marginTop: 2 }} data-testid="gdpr-version">Textul acordului, versiunea {GDPR_TEXT_VERSION}</span>
            </label>
          </div>

          {error && (
            <div style={{ background:"#FEE2E2", color:"#991B1B", padding:"10px 14px",
                borderRadius:6, marginBottom:16, fontSize:13 }} data-testid="login-error">{error}</div>
          )}

          <button className="btn btn-primary" style={{ width:"100%", justifyContent:"center", padding:"11px 16px" }}
              disabled={loading} data-testid="login-submit">
            {loading ? "Se conectează..." : "Autentifică-te"}
          </button>
        </form>)}
      </div>
    </div>
  );
}
